export default {"src":"/_next/static/media/messageLogo.fada48ca.svg","height":344,"width":429,"blurWidth":0,"blurHeight":0};